define('home/templates/followChannelPrompt',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.viewExpired : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"follow-prompt__wrapper\">\n<div class=\"alert -outline spacing-narrow\">\n<div class=\"media\">\n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.favicon : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"media-right\">\n<p class=\"text-larger\">\n"
    + alias2(helpers.gettext.call(alias1,"Enjoy %(channelName)s?",{"name":"gettext","hash":{"channelName":helpers.tag.call(alias1,"strong",{"name":"tag","hash":{"text":(depth0 != null ? depth0.name : depth0)},"data":data})},"data":data}))
    + "\n</p>\n<p class=\"spacing-narrow\">\n"
    + alias2(helpers.gettext.call(alias1,"It's easy to keep up with %(channelName)s. Just follow and you'll start seeing the latest updates in your home feed. You can follow other channels too!",{"name":"gettext","hash":{"channelName":(depth0 != null ? depth0.name : depth0)},"data":data}))
    + "\n</p>\n"
    + ((stack1 = container.invokePartial(partials.genericFollowButton,depth0,{"name":"genericFollowButton","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n</div>\n</div>\n</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"media-left spacing-right\">\n<a href=\"/home/channel/"
    + alias2(alias1((depth0 != null ? depth0.slug : depth0), depth0))
    + "/\">\n<img src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.favicon : stack1), depth0))
    + "\" alt=\""
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\" class=\"img-avatar-lg\">\n</a>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.shouldShowAlert : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true})

});
